import { Form } from '@unform/web';
import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #757575;
    }
  }

  h3 {
    font-family: Sora, sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #101d40;
  }
`;

export const CustomForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  padding: 20px;

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Sora', sans-serif;
    color: #101d40;
  }

  .multi {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;

    & > div {
      min-width: 200px;
      flex: 1;
    }
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    width: 100%;

    & > button {
      max-width: 250px;
      min-width: 200px;
    }
  }
`;

export const ContainerList = styled.div`
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  overflow-x: auto;
`;

export const TableHeader = styled.div`
  display: grid;
  column-gap: 16px;
  grid-template-columns: 80px 160px minmax(220px, 1fr) 120px 140px 120px;
  padding: 16px;
  font-family: Sora, sans-serif;
  font-size: 11px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;
`;

export const TableRow = styled.div`
  display: grid;
  column-gap: 16px;
  grid-template-columns: 80px 160px minmax(220px, 1fr) 120px 140px 120px;
  border-top: 1px solid #e6effb;
  padding: 16px;
  align-items: center;
  background-color: #ffffff;

  p {
    font-family: Sora, sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #101d40;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  font-family: Sora, sans-serif;
  font-size: 14px;
  color: #757575;
`;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 18px;
  border-radius: 5px;
  font-family: Sora, sans-serif;
  font-weight: 600;
  font-size: 15px;
  border: none;
  cursor: pointer;
  background-color: #329bfc;
  color: #ffffff;
  width: 100%;

  &:hover:not(:disabled) {
    background-color: ${darken(0.1, '#329bfc')};
  }

  &:disabled {
    background-color: rgba(0, 0, 0, 0.12);
    cursor: not-allowed;
  }
`;

/** Paginação da lista de inutilizações (Story 4-1 / T4.7). */
export const Paginacao = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 4px;

  span {
    font-family: Sora, sans-serif;
    font-size: 13px;
    color: #757575;
  }

  button {
    height: 32px;
    padding: 0 14px;
    border-radius: 5px;
    border: 1px solid #e6effb;
    background-color: #ffffff;
    font-family: Sora, sans-serif;
    font-weight: 600;
    font-size: 13px;
    color: #329bfc;
    cursor: pointer;

    &:disabled {
      color: #c4c4c4;
      cursor: not-allowed;
    }
  }
`;
